import { devtools } from 'zustand/middleware';
import { create } from 'zustand';

export interface PrivateOfficePasswordStoreState {
  privateOfficePassword?: string;
  setPrivateOfficePassword: (password: string) => void;
}

export const usePrivateOfficePasswordStore = create(
  devtools<PrivateOfficePasswordStoreState>(
    (set) => ({
      privateOfficePassword: undefined,
      setPrivateOfficePassword: (password: string) => set({ privateOfficePassword: password }),
    }),
    {
      name: 'private-office-password',
    },
  ),
);
